export const SORT_OPTIONS = {
  RECENT: "recent",
  TEAM_MEMBER: "teamMember",
};
